export default function forEach(obj, cb) {
    const keys = Object.keys(obj || {});
    keys.forEach((key) => {
        cb(obj[key], key);
    });
}
